import React from "react";

export default function Logo (props) {
    return (
        <img src={"/images/logo@2x.png"} alt={"Mnu Logo"} width={props.width || "20px"}/>
    )
}
